export enum DataProviderType {
  MST = 'MST',
  Intekenen = 'intekenen'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/dataprovidertype.ts